import { Injectable, inject } from '@angular/core';
import { onAuthStateChanged, type User } from 'firebase/auth';
import { SecureStorageService } from './secure-storage.service';
import { FIREBASE_AUTH } from '../firebase-config';

interface PersistedAuthUser extends StoredAuthUser {
  emailVerified?: boolean;
}

export interface StoredAuthUser {
  uid: string;
  email?: string | null;
  firstname?: string;
  emailVerified?: boolean;
}

@Injectable({ providedIn: 'root' })
export class AuthStatePersistenceService {
  private auth = inject(FIREBASE_AUTH);
  private storage = inject(SecureStorageService);

  initializeAuthListener(): () => void {
    return onAuthStateChanged(this.auth, async (user) => {
      if (user) {
        await this.persistAuthUser(user);
      } else {
        await this.clearStoredUser();
      }
    });
  }

  async storeUserLocally(user: StoredAuthUser | ''): Promise<void> {
    if (user === '') {
      await this.clearStoredUser();
      return;
    }

    await this.storage.setObject('user', user);
  }

  async clearStoredUser(): Promise<void> {
    await this.storage.removeItem('user');
  }

  async persistAuthUser(user: User): Promise<void> {
    const persistedUser: PersistedAuthUser = {
      uid: user.uid,
      email: user.email,
      emailVerified: user.emailVerified,
    };

    await this.storage.setObject('user', persistedUser);
  }
}
